export default {
	widgetUserEvent: [
		{
			logic: {
				'eventData.action': 'clicked',
				'eventData.element': 'Save button',
				'eventData.result': 'Vehicle saved'
			},
			payload: {
				directCallEvent: 'mycars.save',
				additionalData: {
					customLink:
						// eslint-disable-next-line max-len
						'[[eventData.widgetId]]:[[eventData.vehicle.year]] [[eventData.vehicle.make]] [[eventData.vehicle.model]] [[eventData.vehicle.trim]]: Save This Car',
					position: '[[eventData.widgetId]]',
					pageName: '[[window.digitalData.pageInfo.pageName]]',
					vehicleInfo: '[[fn.getVehicleInfo]]'
				}
			}
		},
		{
			logic: {
				'eventData.action': 'clicked',
				'eventData.result': 'Email Signup for Price Alert Notification'
			},
			payload: {
				directCallEvent: 'mycars.get.alert',
				additionalData: {
					customLink:
						// eslint-disable-next-line max-len
						'[[eventData.widgetId]]:[[eventData.vehicle.year]] [[eventData.vehicle.make]] [[eventData.vehicle.model]] [[eventData.vehicle.trim]]: Get Price Alerts',
					position: '[[eventData.widgetId]]',
					pageName: '[[window.digitalData.pageInfo.pageName]]',
					vehicleInfo: '[[fn.getVehicleInfo]]'
				}
			}
		}
	]
};
